import { axiosInstance } from '../axios';
import { IPlan } from '../dashboard/types';
import { getNonPaginatedEndpoint } from '../utils';

export function getAgreementPlans({ agreementID }: { agreementID: string }): Promise<IPlan[]> {
  return getNonPaginatedEndpoint(`/subscription/agreement/${agreementID}/plans/`) as Promise<IPlan[]>;
}

export function updateCPF({ cnpj, document_for_cnpj }: { cnpj: string; document_for_cnpj: string }): Promise<void> {
  return axiosInstance.post(`/subscription/first-access-cnpj/`, {
    cnpj,
    cpf: document_for_cnpj,
  }) as Promise<void>;
}
